/**
 * OR-6455: whether the caller may see/open chats they don't own via the
 * internal cross-owner chat visibility capability. Audience is decided
 * entirely by the flag's Split targeting (email list / org domain rule) —
 * there is no separate `isInternalUser` check here or server-side.
 * UX-only — every BE call this gates re-checks the flag independently
 * server-side (matches the OR-6432 `research_assistant_developer_tools`
 * gating pattern in `useAllowedApps.ts`), so a stale/bypassed client-side
 * value here can't grant more than a 403.
 *
 * A single hook rather than each caller inlining
 * `useFeatureFlagSplit(...)` directly — `MaybeActiveChatProvider`,
 * `ActiveChatHeader`, and `ActiveChatBody` all need this SAME answer for
 * the SAME chatId, and a flag-name typo between three inlined copies is
 * exactly the kind of drift that would let one of them (wrongly) decide
 * it's safe to live-subscribe to a chat the others correctly treat as
 * internal-viewer-only.
 */

import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';

export const INTERNAL_CHAT_VISIBILITY_FLAG = 'research_assistant_internal_chat_visibility';

export const useInternalChatVisibilityEnabled = (): boolean => {
  return useFeatureFlagSplit(INTERNAL_CHAT_VISIBILITY_FLAG, false) as boolean;
};
